import { render, staticRenderFns } from "./LittleTip.vue?vue&type=template&id=a652a700"
import script from "./LittleTip.vue?vue&type=script&lang=js"
export * from "./LittleTip.vue?vue&type=script&lang=js"
import style0 from "./LittleTip.vue?vue&type=style&index=0&id=a652a700&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports